import React, { Component } from 'react';
import ReactBootstrap, { Modal, Button, ListGroup, ListGroupItem } from 'react-bootstrap';
import ShowRolesList from './RolesList';
import Logger from './Logger';
import noty from './Noty';
import "../../node_modules/noty/lib/noty.css";  
import "../../node_modules/noty/lib/themes/bootstrap-v4.css"; 

export default class FilterRolesModal extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            roles: [],
            checkList: [],
            temporaryRoles: [],
            isAllSelected: false,
            mainHub: props.hub,
            filter: false
        };
        this.hideModal = this.hideModal.bind(this);
        this.resetModal = this.resetModal.bind(this);
        this.filterRoles = this.filterRoles.bind(this);
        this.getUserRolesCount = this.getUserRolesCount.bind(this);
        this.setCheckList = this.setCheckList.bind(this);
    }

    hideModal() {
        this.props.hideRolesModal(false);
    }

    resetModal() {
        let self = this;
        if ((self.state.checkList.length == self.state.roles.length && !self.state.filter) || self.state.temporaryRoles.length == 0) {
            self.onCheckBoxChange('all', false);
        }
        if (self.state.temporaryRoles.length != 0 && self.state.checkList.length != self.state.temporaryRoles.length) {
            self.state.checkList.map(function (item) {
                item.checked = false
            })
            for (var i = 0; i < self.state.temporaryRoles.length; i++) {
                self.state.checkList.map(function (item) {
                    if (item.name == self.state.temporaryRoles[i].name) {
                        item.checked = true;
                    }
                })
            }
            self.state.checkList.map(function (item) {
                self.onCheckBoxChange(item.name, item.checked)
            })
            self.setState({
                roles: self.state.temporaryRoles
            })
        }
    }

    componentDidMount() {
        this.setCheckList();
    }

    setCheckList() {
        const self = this
        try {
            self.setState({
                checkList: this.props.checkList.map(function (e) {
                    return {
                        name: e.name,
                        value: e.name,
                        checked: false
                    }
                })
            });
            self.getUserRolesCount();
        }
        catch (error) {
            noty('error', 'Something went wrong.')
            Logger('Setting checklist failed.', error.message, error.stack, 'Error');
        }
    }

    getUserRolesCount() {
        let self = this;
         self.state.mainHub.invoke('GetUsersRolesCount', self.props.simulationID)
            .then(function (response) {
                console.log(response);
                let data = [];
                self.state.checkList.map(function (e) {
                    response.map(function (o) {
                        if (e.name.trim() == o.Roles.trim()) {
                            data.push({
                                name: e.name,
                                value: e.value,
                                checked: e.checked,
                                users: o.Users
                            })
                        }
                    })
                })
                self.setState({
                    checkList: data
                })
                console.log(self.state.checkList)
            })
            .catch(function (error) {
                noty('error', 'Something went wrong.')
                Logger('Failed to get user roles count.', error.message, error.stack, 'Error');
            });
    }

    filterRoles() {
        this.setState({
            temporaryRoles: this.state.roles,
            filter: true
        })
        if (this.state.checkList.length == this.state.roles.length) {
            this.setState({
                filter: false
            })
        }
        this.props.filter(this.state.roles)
    }

    onCheckBoxChange(checkName, isChecked) {
        let isAllChecked = (checkName === 'all' && isChecked);
        let isAllUnChecked = (checkName === 'all' && !isChecked);
        const checked = isChecked;

        const checkList = this.state.checkList.map((role, index) => {
            if (isAllChecked || role.value === checkName) {
                return Object.assign({}, role, {
                    checked,
                });
            } else if (isAllUnChecked) {
                return Object.assign({}, role, {
                    checked: false,
                });
            }
            return role;
        });
        let isAllSelected = (checkList.findIndex((item) => item.checked === false) === -1) || isAllChecked;
        isAllSelected = (this.state.checkList.length == 0) ? false : isAllSelected
        let roles = checkList.filter((item) => item.checked === true);
        this.setState({
            checkList,
            isAllSelected,
            roles
        });
    }

    render() {
        return (
            <div>
                <Modal
                    size="lg"
                    show={this.props.onChange}
                    onHide={this.props.hideModal}
                    container={this}
                    aria-labelledby="contained-modal-title"

                >
                    <Modal.Header closeButton onClick={this.resetModal}>
                        <Modal.Title id="contained-modal-title">
                            Roles
            </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="modal-sub-title">List of Selected Roles</div>
                        <div className="roles-list-block">
                            <ShowRolesList
                                checkList={this.state.checkList}
                                isAllSelected={this.state.isAllSelected}
                                onCheck={this.onCheckBoxChange.bind(this)}
                            />
                        </div>
                        <div className="clearfix">
                            <div className="float-right">
                                <Button className="" onClick={this.filterRoles} variant="success" href="#">Filter</Button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}